@if (!kunde) {
  <div>
    <div class="data no-margin-top">
      <div class="data__val">
        <mat-icon svgIcon="obs-solid"></mat-icon>
        <span>Vi kan ikke finde kundeaftalen i G4.</span>
      </div>
    </div>
  </div>
}
@if (kunde) {
  <div>
    <div class="data no-margin-top tiny-text">
      <p>
        <strong class="tiny-text">Kontakt og anlægsadr.</strong>
        <br />
        <span class="icon-with-text">
          <span>Kunde #{{ kunde?.okKundeNr }}</span>
          <app-copy class="margin--left-xs" [content]="getKundeInfo()" [matTooltip]="'Kopiér kundens informationer'"></app-copy>
        </span>
      </p>
      <p>
        @if (kunde?.anlaegsadresse?.name) {
          <span class="icon-with-text">
            <span>{{ kunde?.anlaegsadresse?.name }}</span>
          </span>
        }
        {{ kunde?.anlaegsadresse?.adressLine }}
        <br />
        @if (kunde?.lokation) {
          {{ kunde?.lokation }}
        }
      </p>
      @if (kunde?.anlaegsadresse?.contact) {
        <p>Kontaktperson: {{ kunde?.anlaegsadresse?.contact }}</p>
      }
      <p>
        @if (kunde?.anlaegsadresse?.phone) {
          <span class="icon-with-text">
            T: {{ $safeNavigationMigration(kunde?.anlaegsadresse?.phone) | dkPhoneNumber }}
            <app-copy class="margin--left-xs" [content]="$safeNavigationMigration(kunde?.anlaegsadresse?.phone)" [matTooltip]="'Kopiér kundens telefonnummer'"></app-copy>
          </span>
        }
        @if (kunde?.anlaegsadresse?.mobile) {
          <span class="icon-with-text">
            M: {{ $safeNavigationMigration(kunde?.anlaegsadresse?.mobile) | dkPhoneNumber }}
            <app-copy class="margin--left-xs" [content]="$safeNavigationMigration(kunde?.anlaegsadresse?.mobile)" [matTooltip]="'Kopiér kundens mobilnummer'"></app-copy>
          </span>
        }
        <a href="mailto:{{ kunde?.anlaegsadresse?.email }}" class="ellipsis" title="Send mail til {{ kunde?.anlaegsadresse?.email }}">
          {{ kunde?.anlaegsadresse?.email }}
        </a>
        <span class="block">
          @if (kunde?.kundeExtendedInformation?.superOfficeUrl) {
            <span>
              <a
                href="{{ kunde?.kundeExtendedInformation?.superOfficeUrl }}"
                target="_blank"
                rel="noopener noreferrer"
                class="btn-icon external-link"
                >
                <mat-icon>chevron_right</mat-icon>
                <span>Vis kunde i SuperOffice</span>
              </a>
            </span>
          }
          @if (!kunde?.kundeExtendedInformation.superOfficeUrl) {
            <span>
              <i>Findes ikke i SuperOffice!</i>
            </span>
          }
        </span>
        <span class="block">
          @if (kunde?.kontoAdresse?.adresseIdG4 !== kunde?.anlaegsadresse?.adresseIdG4) {
            <span>
              <button type="button" (click)="openBetaler()" class="btn-icon blue">
                <mat-icon svgIcon="obs-solid" class="blue"></mat-icon>
                Betaler
              </button>
            </span>
          }
          @if (kunde?.kontoAdresse?.adresseIdG4 === kunde?.anlaegsadresse?.adresseIdG4) {
            <i>Betaler- og anlægsadresse er ens.</i>
          }
        </span>
      </p>
      <div class="produktcyklus">
        <div>Produktcyklus</div>
        <app-produkt-cyklus-icon [produkt]="fyringsolieProdukt" [kunde]="kunde" style="margin-left: auto"></app-produkt-cyklus-icon>
        <app-produkt-cyklus-icon [produkt]="gasProdukt" [kunde]="kunde"></app-produkt-cyklus-icon>
        <app-produkt-cyklus-icon [produkt]="elProdukt" [kunde]="kunde"></app-produkt-cyklus-icon>
      </div>
    </div>
  </div>
}
